module.exports = __webpack_public_path__ + "static/img/c8.79bea30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/c8.png
// module id = 282
// module chunks = 0 1 2 3 4 5 6 7 8 9